var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleavatar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1945_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1946_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1947_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1948_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1949_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1950_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1951_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1952_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1953_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1954_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1955_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1956_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1957_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1958_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 65.98-24.96 126.13-65.95 171.52-23.17 25.66-51.46 11.64-83.26-9.08-32.51-21.18-68.67-49.36-106.79-49.36-75.41 0-143.2 110.32-190.05 58.44-40.99-45.39-65.95-105.54-65.95-171.52 0-141.38 114.62-256 256-256 129.13 0 235.94 95.62 253.48 219.92 1.66 11.79 2.52 23.83 2.52 36.08z",
    fill: "#336b90"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 65.98-24.96 126.13-65.95 171.52-23.17 25.66-51.46 11.64-83.26-9.08l-71.74-178.96 56.87-181.13 161.56 161.57c1.66 11.79 2.52 23.83 2.52 36.08z",
    fill: "#205077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.47 154.164c0-142.751-123.47-126.702-123.47-126.702s-123.47-16.049-123.47 126.702c0 60.843-15.407 92.481-25.167 116.772-14.743 36.697 12.349 76.659 51.896 76.659h193.481c39.548 0 66.64-39.962 51.897-76.659-9.759-24.291-25.167-55.929-25.167-116.772z",
    fill: "#fbe280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.74 347.6h-96.74v-320.14s123.47-16.05 123.47 126.7c0 60.85 15.41 92.48 25.17 116.78 14.74 36.69-12.35 76.66-51.9 76.66z",
    fill: "#efc859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.97 250.232h112.06v118.84h-112.06z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 250.236h56.03v118.84h-56.03z",
    fill: "#d38c5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.97 324.82h112.06v121.31h-112.06z",
    fill: "#ffc397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 324.82h56.03v121.31h-56.03z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m446.05 382.27v45.25c-46.86 51.88-114.65 84.48-190.05 84.48s-143.19-32.6-190.05-84.48v-45.25c0-31.73 25.72-57.45 57.45-57.45h76.57v32.64c0 30.95 25.09 56.03 56.03 56.03 15.47 0 29.48-6.27 39.62-16.41s16.41-24.14 16.41-39.62v-32.64h76.57c31.73 0 57.45 25.72 57.45 57.45z",
    fill: "#ea9611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.05 382.27v45.25c-46.86 51.88-114.65 84.48-190.05 84.48v-98.51c15.47 0 29.48-6.27 39.62-16.41s16.41-24.14 16.41-39.62v-32.64h76.57c31.73 0 57.45 25.72 57.45 57.45z",
    fill: "#cc7a05"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m157.33 419.645v72.625c-11.17-4.66-21.95-10.11-32.25-16.25v-56.375z",
    fill: "#cc7a05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.92 419.645v56.375c-10.3 6.14-21.08 11.59-32.25 16.25v-72.625z",
    fill: "#af5e22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.251 152.225c-3.728-56.6-49.511-77.517-88.251-77.517s-84.523 20.917-88.251 77.517c-10.018 1.938-17.134 15.077-16.014 25.701l1.717 24.177c1.175 11.157 10.982 19.301 21.79 18.089l1.864-.202c22.139 59.446 56.857 65.644 78.894 69.125 22.037-3.48 56.756-9.678 78.894-69.125l1.864.202c10.807 1.212 20.614-6.932 21.79-18.089l1.717-24.177c1.12-10.624-5.996-23.763-16.014-25.701z",
    fill: "#ffc397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.265 177.926-1.717 24.177c-1.175 11.157-10.982 19.301-21.79 18.089l-1.864-.202c-7.566 20.293-16.592 34.388-26.078 44.277-18.291 19.081-38.299 22.552-52.817 24.847v-214.406c38.74 0 84.523 20.917 88.251 77.517 10.019 1.938 17.135 15.077 16.015 25.701z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.447 56.217s-57.799-20.815-90.724 23.709c-37.524 50.743 16.445 112.689 16.445 112.689s11.862-21.567 38.821-40.53c7.818-5.5 14.075-11.746 19.031-17.845 10.527 20.867 36.269 54.676 93.478 58.375 0 0 25.676-43.118 25.881-72.251.243-34.507-28.037-83.108-102.932-64.147z",
    fill: "#fbe280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.38 120.36c-.21 29.14-25.88 72.26-25.88 72.26-39.19-2.53-63.62-19.2-78.5-36.16v-100.72c.95.3 1.45.48 1.45.48 74.89-18.96 103.17 29.64 102.93 64.14z",
    fill: "#efc859"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleavatar4);
export default __webpack_public_path__ + "static/media/Femaleavatar_4.ebaca5f22c16dc0b57df99cc7cf46f8b.svg";
export { ForwardRef as ReactComponent };